import {Component, OnInit} from "@angular/core";
import {StromcheckRequestService} from "../services/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {EmbedService} from "../../services/embed.service";
import {Step, Steps, StepService} from "../../services/step.service";
import {StromcheckAnfrage} from "../anfrage/stromcheck.anfrage";
import {StepComponent} from "../../step/step.component";
import {EingabeForm} from "../eingabe/eingabe.form";

/**
 * Component for the entry of the wpcheck.
 */
@Component({
  selector: 'app-stromcheck-einstieg',
  templateUrl: './einstieg.component.html'
})
export class EinstiegComponent extends StepComponent implements OnInit {

  /**
   * constructor
   * @param requestService
   * @param router
   * @param elementService
   * @param activatedroute
   * @param portalService
   * @param embedService
   * @param stepService
   */
  constructor(protected requestService: StromcheckRequestService, protected router: Router,
              protected elementService: ElementService, protected activatedroute: ActivatedRoute, protected  portalService: PortalService,
              protected embedService: EmbedService, protected stepService: StepService) {
    super(stepService, router, elementService)
  }

  /**
   * the current userdata
   */
  anfrage: StromcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * target of the link of the short version
   */
  shortVersionButtonUrl: string;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    //add form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    //get the current and next step
    this.steps = new Steps();
    this.steps.currentStep = new Step('kurz', '');

    //add relevant form
    this.form = this.formConfig.getForm('kurz');

    //get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.setData(this.anfrage.userInput);

    // url for short version
    this.activatedroute.data.subscribe(data => {
      // try to get button URL from the portal config, fallback to local URL if it is not there
      this.shortVersionButtonUrl = this.portalService.getConfig('stromcheck.short.buttonlink');
      if (this.shortVersionButtonUrl === null) {
        this.shortVersionButtonUrl = this.router.url + '/../start';
      }
    });

  }

  /**
   * save the selection of gebaeudetyp
   */
  saveData(): void {
    //get the data and merge with user input
    const data = this.formConfig.getData();
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};

    // save data to local browser
    this.requestService.setAnfrage(this.anfrage);
    // save to server
    this.requestService.saveDataToServer();
  }

}
